module.exports = __webpack_public_path__ + "static/media/smile.28ff52a8.svg";